import { render, staticRenderFns } from "./SchoolTypeModal.vue?vue&type=template&id=fa064eba&"
import script from "./SchoolTypeModal.vue?vue&type=script&lang=js&"
export * from "./SchoolTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports